import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const startEditingCustomLabel = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) => {
    if (!plugin.config.createCustom) {
      // Cannot do this if custom creation is not enabled
      return
    }
    return feature.actions.startEditingCustomLabel.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        availableItems: feature.selectors.getAvailableItems({
          selectionTarget: action.data.selectionTarget,
        }).asObservable,
        entityUsageLookup: feature.selectors.entityUsageLookup.asObservable,
      })),
      rxjs.map(({ action, availableItems, entityUsageLookup }) => {
        // FIXME: currently, this just creates a new custom label everytime,
        // even when it copies the value of the old custom label. What should
        // happen is when the user is overwriting an existing custom label, it
        // should actually replace that label in the list. To do so, we need to
        // store the id of the custom label in the state and use it to update
        // the existing entity on submit

        // FIXME: it actually seems like the overwrite label is never set, even
        // when it should be

        let overwritableLabel: string | undefined
        // Tries to find an overwritable item
        for (const item of availableItems) {
          const id = item.value
          if (!ec.models.EntityId.isEntityId(id)) {
            // Can only overwrite an item that corresponds to an entity ID
            continue
          }
          const usage = entityUsageLookup[id]
          if (
            usage &&
            usage.deletable &&
            usage.referencedBy.size -
              (usage.referencedBy.has(action.data.selectionTarget) ? 1 : 0) ===
              0
          ) {
            // If we know that this item is deletable and is only referenced by
            // this selection target, then we can overwrite it
            overwritableLabel = item.label
            break
          }
        }
        return plugin.feature.actions.editCustomLabel.from(action).create({
          label: overwritableLabel,
          selectionTarget: action.data.selectionTarget,
        })
      }),
    )
  },
)
